module.exports = __webpack_public_path__ + "1350b915415f11ab5cb342858f8a3fef.svg";